import { useRef, useEffect, createElement } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { CSSRefTransition } from '@utils/react';
import { useVirtualizedTable } from './hooks/useVirutalizedBody.js';
import { tableCls, TRANSITION_DURATION_MS, transitionCls } from './styles.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Table(props) {
  const tableRef = useRef(null);
  useEffect(() => {
    const table = tableRef.current;
    if (!table) {
      return;
    }
    table.style.setProperty("--header-height", `${props.headerHeight}px`);
  }, [props.headerHeight]);
  return /*#__PURE__*/jsxs("table", {
    ref: tableRef,
    className: tableCls,
    children: [props.children, /*#__PURE__*/jsx(TransitionGroup, {
      component: null,
      children: /*#__PURE__*/createElement(Body, {
        ...props,
        tableRef: tableRef,
        key: props.contentKey
      })
    })]
  });
}
function Body({
  contentKey,
  renderRow,
  rowComparator,
  rowHeight,
  rows,
  extraRowsToRender,
  tableRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  headerHeight,
  ...transitionProps
}) {
  const bodyRef = useRef(null);
  useVirtualizedTable({
    renderRow,
    rowComparator,
    contentKey,
    rows,
    rowHeight,
    extraRowsToRender: extraRowsToRender ?? 16,
    tableRef,
    bodyRef
  });
  return /*#__PURE__*/createElement(CSSRefTransition, {
    ...transitionProps,
    nodeRef: bodyRef,
    key: contentKey,
    classNames: transitionCls,
    timeout: TRANSITION_DURATION_MS
  }, ref => /*#__PURE__*/jsx("tbody", {
    ref: ref
  }));
}

export { Table };
//# sourceMappingURL=Table.js.map
